import { SubDomain } from "../../SubDomain";
import CheckListVersion from "./CheckListVersion.js";

export default class CheckListVersionsDomain extends SubDomain {

  constructor(domain, storage) {
    super(domain, CheckListVersion.MODEL_NAME);
    // A store without the module (an older bundle, or a test) reads as holding nothing.
    this._storage = (storage && storage.CheckListVersionStorage) || { list: [], map: {} };
  }

  list() {
    return this._storage.list;
  }

  findById(objId) {
    var object = this._storage.map[objId];
    return new CheckListVersion(this.domain, object);
  }
}
